import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { yandexReachGoal } from 'cityads-v3/utils/counterUtils';

import CopyTextField from 'cityads-v3/components/CopyTextField/CopyTextField';
import MicrosoftAdsIntegrationButton from '../tools/adsIntegration/Microsoft/IntegrationButton';

import classes from './OfferGetLink.scss';

export default function GetLinkTabPanelMicrosoft({ finalUrl, trackingTemplate, finalUrlSuffix, offerId }) {
  const { t } = useTranslation(['Offers']);

  const onCopyFinalUrl = useCallback(() => {
    yandexReachGoal('COPY_MICROSOFT_FINAL_URL')
  }, [])

  return (
    <div className={classes.linkTabPanel}>
      <CopyTextField
        copyOnFocus
        label               = {t('exports.finalUrl')}
        helperText          = {t('exports.finalUrlHelper')}
        multiline           = {false}
        fullWidth           = {true}
        value               = {finalUrl || ''}
        InputLabelProps     = {{ shrink: true }}
        FormHelperTextProps = {{ className: classes.trackingInputHelper }}
        margin              = "normal"
        onCopyText          = {onCopyFinalUrl}
      />
      <CopyTextField
        copyOnFocus
        label               = {t('exports.trackingTemplate')}
        helperText          = {t('exports.trackingTemplateHelperMicrosoft')}
        multiline           = {false}
        fullWidth           = {true}
        value               = {trackingTemplate || ''}
        InputLabelProps     = {{ shrink: true }}
        FormHelperTextProps = {{ className: classes.trackingInputHelper }}
        margin              = "normal"
      />
      <CopyTextField
        copyOnFocus
        label               = {t('exports.finalUrlSuffix')}
        helperText          = {t('exports.finalUrlSuffixHelperMicrosoft')}
        multiline           = {false}
        fullWidth           = {true}
        value               = {finalUrlSuffix || ''}
        InputLabelProps     = {{ shrink: true }}
        FormHelperTextProps = {{ className: classes.trackingInputHelper }}
        margin              = "normal"
      />

      <hr />
      <MicrosoftAdsIntegrationButton offerId={offerId} />
    </div>
  );
}
